import React from 'react';
import styled from 'styled-components';

import { space, Space } from 'style/spacing';
import { theme } from 'assets/styles/theme';

const StyledButton = styled.button<Space>`
  background: transparent;
  border: none;
  position: relative;
  width: 50px;
  height: 30px;
  outline: none;
  cursor: pointer;
  z-index: 101;

  ${space};

  .item {
    border-top: solid 3px white;
    width: 38px;
    display: inline-block;
    position: absolute;
    left: 5px;
    transition: transform 0.3s, opacity 0.3s;
  }

  .item1 {
    /* top: 5px; */
    top: 0px;
  }
  .item2 {
    /* top: 18px; */
    top: 13px;
  }
  .item3 {
    /* top: 31px; */
    top: 26px;
  }

  .item1.open {
    transform: rotate(45deg) translate(10px, 8px);
  }
  .item2.open {
    transform: rotate(-45deg) translate(1px, 1px);
  }
  .item3.open {
    opacity: 0;
    transform: translateX(23px);
  }
`;

interface HamburgerButtonProps extends Space {
  isOpen: boolean;
  handleClick: () => void;
}

export const HamburgerButton: React.FC<HamburgerButtonProps> = ({
  isOpen,
  handleClick,
  ...rest
}) => {
  return (
    <StyledButton onClick={handleClick} {...rest}>
      <span className={`item item1 ${isOpen ? 'open' : ''}`}>
        <span
          style={{
            position: 'absolute',
            display: 'inline-block',
            width: 10,
            height: 10,
            background: theme.colors.greySelected,
            border: '2px solid white',
            borderRadius: '50%',
            top: -6,
            opacity: isOpen ? 0 : 1,
            transition: 'all 0.2s',
          }}
        ></span>
      </span>
      <span className={`item item2 ${isOpen ? 'open' : ''}`}>
        <span
          style={{
            position: 'absolute',
            display: 'inline-block',
            width: 10,
            height: 10,
            background: theme.colors.greySelected,
            border: '2px solid white',
            borderRadius: '50%',
            top: -6,
            left: 6,
            opacity: isOpen ? 0 : 1,
            transition: 'all 0.2s',
          }}
        ></span>
      </span>
      <span className={`item item3 ${isOpen ? 'open' : ''}`}>
        <span
          style={{
            position: 'absolute',
            display: 'inline-block',
            width: 10,
            height: 10,
            background: theme.colors.greySelected,
            border: '2px solid white',
            borderRadius: '50%',
            top: -6,
            left: 13,
            opacity: isOpen ? 0 : 1,
            transition: 'all 0.2s',
          }}
        ></span>
      </span>
    </StyledButton>
  );
};
